import React, { useCallback } from "react";
import MockTest from "../../components/SatCourse/MockTest";
import { useNavigate } from "react-router-dom";

const MockTestScreen: React.FC = () => {
  const navigate = useNavigate();

  const HandleId = useCallback(() => {
    navigate("/mockinfo");
  }, [navigate]);

  return (
    <>
      <MockTest HandleId={HandleId} />
    </>
  );
};
export default MockTestScreen;
